var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.00001C9.91166 1.99876 9.82395 2.01508 9.74197 2.04802C9.65999 2.08096 9.58538 2.12987 9.52247 2.1919C9.45955 2.25393 9.4096 2.32784 9.3755 2.40935C9.3414 2.49085 9.32384 2.57832 9.32384 2.66667C9.32384 2.75502 9.3414 2.84249 9.3755 2.924C9.4096 3.0055 9.45955 3.07942 9.52247 3.14145C9.58538 3.20348 9.65999 3.25238 9.74197 3.28533C9.82395 3.31827 9.91166 3.33459 10 3.33334C13.6897 3.33334 16.6667 6.31032 16.6667 10C16.6667 13.6897 13.6897 16.6667 10 16.6667C6.31031 16.6667 3.33333 13.6897 3.33333 10C3.33333 8.4335 3.87236 6.9979 4.77344 5.86198L6 7.33334L7.33333 2.66667L2.66667 3.33334L3.91146 4.82683C2.72444 6.22338 2 8.02786 2 10C2 14.4103 5.58969 18 10 18C14.4103 18 18 14.4103 18 10C18 5.58969 14.4103 2.00001 10 2.00001Z",
    fill: "#474B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.8042297e7d5136e44fb731456b28bf9d.svg";
export { ForwardRef as ReactComponent };